/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, EventEmitter, Input, Output} from '@angular/core';
import template from './workspace-edit-workspace.component.html';

import type {WorkspaceGridsterResource} from './workspace-gridster-item.component';

@Component({
  standalone: false,
  selector: 'adn-workspace-edit-workspace',
  template
})
export class WorkspaceEditWorkspaceComponent {
  @Input() widgets: any[] = [];
  @Input() pending = false;
  @Input() gridsterOpts: any;
  @Input() gridsterResource: WorkspaceGridsterResource;

  readonly layoutChangeHandler = () => this.layoutChange.emit();

  @Output() addWidgets = new EventEmitter<void>();
  @Output() layoutChange = new EventEmitter<void>();
}
